<i18n>
{
  "fr": {
    "edit-label": "Modifier",
    "cancel-label": "Annuler",
    "save-label": "Sauvegarder"
  },
  "en": {
    "edit-label": "Edit",
    "cancel-label": "Cancel",
    "save-label": "Save"
  }
}
</i18n>
<template>
  <div v-if="editing">
    <slot name="editor" v-bind="{ model: editModel, update: (v) => (editModel = v) }" />

    <div>
      <b-button key="cancel" type="is-link" size="is-small" outlined class="mr-12px" @click="cancelEditing">
        {{ $t('cancel-label') }}
      </b-button>
      <b-button key="save" type="is-link" size="is-small" @click="save">
        {{ saveLabel || $t('save-label') }}
      </b-button>
    </div>
  </div>
  <div v-else>
    <slot />

    <div v-if="$scopedSlots.readModeButtons">
      <slot name="readModeButtons" v-bind="{ startEditing, editLabel: editLabel || $t('edit-label') }" />
    </div>
    <div v-else>
      <b-button
        key="edit"
        type="is-text has-text-link has-text-decoration-none"
        @click="startEditing"
        outlined
        size="is-small"
        icon-left="edit"
        style="margin-left: -6px"
        :disabled="readOnly"
      >
        {{ editLabel || $t('edit-label') }}
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    editLabel: String,
    saveLabel: String,
    value: {},
    readOnly: Boolean
  },
  data() {
    return {
      editing: false,
      editModel: null
    }
  },
  methods: {
    startEditing() {
      this.editing = true
      this.editModel = JSON.parse(JSON.stringify(this.value))

      this.$emit('start-editing')
    },
    cancelEditing() {
      this.editing = false
      this.editModel = null

      this.$emit('cancel-editing')
    },
    save() {
      const saveEvent = {
        value: this.editModel,
        closeEditor: () => {
          this.editing = false
          this.editModel = null
        }
      }

      this.$emit('save', saveEvent)
    }
  }
}
</script>